var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.75,
    height: 14.98,
    viewBox: "0 0 11.75 14.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59.13,1,5.27a.37.37,0,0,0,.28.62H3.9v5.47a.38.38,0,0,0,.38.38H7.47a.38.38,0,0,0,.38-.38V5.89h2.62a.37.37,0,0,0,.28-.62L6.15.13a.37.37,0,0,0-.56,0ZM11.51,15H.24A.24.24,0,0,1,0,14.74V13.47a.24.24,0,0,1,.24-.24H11.51a.24.24,0,0,1,.24.24v1.27A.24.24,0,0,1,11.51,15Z",
    fill: "#624de3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e36e7a08e1a456e1b8b688337a4c2b1e.svg";
export { ForwardRef as ReactComponent };